import Component from './trainingsV2.component';
import { Config } from './trainingsV2.config';

export default { Component, config: Config };
